interface CloseIconProps {
  width?: number | string
  height?: number | string
  color?: string
  onClick?: () => void
  className?: string
}

const CloseIcon = (props: CloseIconProps): JSX.Element => {
  const { width, height, color, onClick, className } = props

  return (
    <svg
      className={className}
      onClick={onClick}
      width={width ? width : '20'}
      height={height ? height : '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8752 13.7002C14.9541 13.7784 14.9985 13.8849 14.9985 13.996C14.9985 14.1071 14.9541 14.2136 14.8752 14.2919L14.2919 14.8752C14.2136 14.9541 14.1071 14.9984 13.996 14.9984C13.8849 14.9984 13.7784 14.9541 13.7002 14.8752L10.0002 11.1752L6.3002 14.8752C6.22197 14.9541 6.11547 14.9984 6.00437 14.9984C5.89327 14.9984 5.78677 14.9541 5.70854 14.8752L5.1252 14.2919C5.04632 14.2136 5.00195 14.1071 5.00195 13.996C5.00195 13.8849 5.04632 13.7784 5.1252 13.7002L8.8252 10.0002L5.1252 6.3002C5.04632 6.22197 5.00195 6.11547 5.00195 6.00437C5.00195 5.89327 5.04632 5.78677 5.1252 5.70854L5.70854 5.1252C5.78677 5.04632 5.89327 5.00195 6.00437 5.00195C6.11547 5.00195 6.22197 5.04632 6.3002 5.1252L10.0002 8.8252L13.7002 5.1252C13.7784 5.04632 13.8849 5.00195 13.996 5.00195C14.1071 5.00195 14.2136 5.04632 14.2919 5.1252L14.8752 5.70854C14.9541 5.78677 14.9985 5.89327 14.9985 6.00437C14.9985 6.11547 14.9541 6.22197 14.8752 6.3002L11.1752 10.0002L14.8752 13.7002Z"
        fill={color ? color : '#536976'}
      />
    </svg>
  )
}

export default CloseIcon
